export default function FilterButton({
  onClick,
  className = "",
  title = "Filter",
}) {
  return (
    <button
      type="button"
      className={`btn btn-outline-secondary d-inline-flex align-items-center justify-content-center ${className}`}
      onClick={onClick}
      title={title}
      aria-label={title}
      style={{ width: 40, height: 38 }}
    >
      {/* simple “filter” icon (no extra libs) */}
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M4 6h16M7 12h10M10 18h4"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
}
